module.exports = __webpack_public_path__ + "img/partner-hover5.7a835834.png";